import { FormListFieldData } from 'antd/lib/form/FormList';

export const getFormItemName = ({ field, name }: { field?: FormListFieldData; name: string }) =>
  field ? [field.name, name] : name;
